import type { RouteRecordRaw } from 'vue-router';

export const requestRoutes: Array<RouteRecordRaw> = [
  {
    path: '/request',
    name: 'request',
    redirect: '/request/list',
    component: () => import('pages/trade/admin/request/McRequest.vue'),
    meta: {
      title: 'Requests',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'requestList',
        component: () => import('pages/trade/admin/request/RequestList.vue'),
        meta: {
          title: 'Requests List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail',
        name: 'requestDetail',
        component: () => import('pages/trade/admin/request/RequestDetail.vue'),
        meta: {
          title: 'Request Details',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'cancelOrderRequest',
        component: () => import('pages/trade/admin/request/CancelOrder.vue'),
        meta: {
          title: 'Cancel Order Request',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'cancelItemRequest',
        component: () => import('pages/trade/admin/request/CancelItem.vue'),
        meta: {
          title: 'Cancel Order Item(s) Request',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'returnRequest',
        component: () => import('pages/trade/admin/request/ReturnItem.vue'),
        meta: {
          title: 'Return Item(s) Request',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'exchangeRequest',
        component: () => import('pages/trade/admin/request/ExchangeItem.vue'),
        meta: {
          title: 'Exchange Item(s) Request',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'requestNew',
        component: () => import('pages/trade/admin/request/RequestNew.vue'),
        meta: {
          title: 'New Request',
          requiresAuth: true,
        },
      },
    ],
  },
];
